/**
 * Service: customers
 */
angular.module('acme.common.service.customers', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.customers.modals.order.controllers'
])
.service('CustomersService', ['$state', '$uibModal', function($state, $uibModal) {

    return {

      name: 'customers',
      key: 'enableCustomersOrgCheckout',

      init: function() {
        return true;
      },

      /**
       * Prompts using modal in the final location where the feature will eventually live
       * This functionality is currently encapsulated within the feature
       * If this flag is removed we will want to migrate this code into the view where
       * this method is called from
       *
       * @param customer
       */
      prompt: function(customer) {

        var self = this;

        self.createModal = $uibModal.open({
          templateUrl: 'views/application/views/customers/modals/order/order.tpl.html',
          size: 'md',
          controller: 'CustomersModalsOrderController',
          resolve: {
            customer: function () {
              return customer;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.createModal.result.then(function (response) {
          $state.go('application.orders.create', response.params);
        }, function () {
          // Do nothing
        });
      }

    };

}]);